<template>
    <vx-card title="Настройки процесса внутреннего баинга" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <h5>Словарь ГЕО для рассчета дашбордов:</h5>
                    <vs-table :data="countries" max-items="10" class="mt-5">
                        <template slot="thead">
                            <vs-th> Id </vs-th>
                            <vs-th> Название</vs-th>
                            <vs-th> Норма CPC </vs-th>
                            <vs-th> Процент выкупа</vs-th>
                            <vs-th> Действия </vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td>{{ tr.id }}</vs-td>
                                <vs-td>{{ tr.countryName }}</vs-td>
                                <vs-td>{{ tr.cpcStandard }}</vs-td>
                                <vs-td>{{ tr.buyoutPercent }}</vs-td>
                                <vs-td>
                                    <div class="inline-block">
                                        <router-link :to="{ name: 'teaser-buying-dashboard-country-edit', params: { id: tr.id } }">
                                            <vx-tooltip text="Редактировать страну" position="top" delay=".3s">
                                                <feather-icon icon="Edit2Icon" class="inline-block mr-2" svgClasses="w-7 h-7" />
                                            </vx-tooltip>
                                        </router-link>
                                    </div>
                                    <div v-if="!tr.deletedAt" class="inline-block cursor-pointer">
                                        <vx-tooltip text="Удалить страну" position="top" delay=".3s">
                                            <feather-icon
                                                @click="showDeleteModal(tr)"
                                                icon="XCircleIcon"
                                                class="inline-block mr-2 text-danger"
                                                svgClasses="w-7 h-7"
                                            />
                                        </vx-tooltip>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                    <vs-button class="mt-5 mr-2 float-left" color="success" @click="createCountry()" type="filled"> Добавить страну </vs-button>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <div class="mt-5"></div>
                    <h5>Настройка A/B дашборда:</h5>
                    <v-select
                        multiple
                        :options="dicts.users"
                        label="email"
                        placeholder="Выберите пользователей"
                        class="w-full"
                        v-bind:class="{ 'select-error': !!errors.buyers }"
                        v-model="form.buyersAbTest"
                    >
                    </v-select>
                </div>
                <div class="mt-5">
                    <h5>Настройка ТОП БАЙЕРОВ:</h5>

                    <v-select
                        multiple
                        :options="dicts.users"
                        label="email"
                        placeholder="Выберите пользователей"
                        class="w-full"
                        v-bind:class="{ 'select-error': !!errors.buyers }"
                        v-model="form.buyersTop"
                    >
                    </v-select>
                </div>
                <vs-button class="mt-5 mr-2 float-right" color="success" @click="saveSettings()" type="filled"> Сохранить </vs-button>
                <vs-button class="mt-5 mr-2 float-right" color="primary" @click="clearEdit()" type="filled"> Отменить </vs-button>
            </div>
        </div>
        <sweet-modal ref="deleteModal" icon="warning" title="Удаление страны">
            <div class="mb-5">Вы действительно хотите удалить страну '{{ selected.countryName }}'?</div>
            <div class="mb-5">Она будет удалена из списка гео для рассчета дашбордов тизерного баинга.</div>
            <vs-button class="" color="danger" @click="deleteCountry(selected)" type="filled"> Удалить страну </vs-button>
        </sweet-modal>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    props: ['id'],
    data() {
        return {
            selected: {},
            settings: undefined,
            countries: [],
            buyers: [],
            form: {
                buyersAbTest: [],
                buyersTop: []
            },
            errors: {
                buyers: '',
                normCoeffsBuyoutsThreshold: ''
            },
            dicts: {
                users: []
            }
        };
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('DashboardBuyingTypeCountries/4/buying-type'), 
                      this.axios.get('Users?buyingTypeId=4'),
                      this.axios.get('Settings/dashboard-buying-type'),
                    ])
                .then(
                    axios.spread((countries, users,settings) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.countries = countries.data;
                        this.dicts.users = users.data;                        
                        this.setSettings(settings.data);
                    })
                )
                .catch((err) => {                    
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки настроек.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        setSettings(settings) {
            
            let teaserBuyingAbTestsBuyersIds = settings.teaserBuyingAbTestsBuyersIds.split(',').map(Number);;
            let teaserBuyingTopBuyersIds = settings.teaserBuyingTopBuyersIds.split(',').map(Number);;
            
            this.form.buyersAbTest =  this.dicts.users.filter((c) => teaserBuyingAbTestsBuyersIds.includes(c.id));
            this.form.buyersTop = this.dicts.users.filter((c) => teaserBuyingTopBuyersIds.includes(c.id));
        },
        clearEdit() {
            this.setSettings(this.settings);
        },
        saveSettings() {
            const params = {
                teaserBuyingAbTestsBuyersIds:  this.form.buyersAbTest ? this.form.buyersAbTest.map((buyer) => buyer.id).join(',') : '',
                teaserBuyingTopBuyersIds:this.form.buyersTop ? this.form.buyersTop.map((buyer) => buyer.id).join(',') : '', 
            };

            let error = '';

            if (error) {
                return this.$vs.notify({
                    title: 'Внимание!',
                    text: error,
                    color: 'danger'
                });
            }

            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: 'settings/dashboard-buying-type',
                params: params,
                errors: this.errors,
                success: (response) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Настройки успешно обновлены',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сохранении настроек!',
                        color: 'danger'
                    });
                }
            });
        },
        createCountry() {
            this.$router.push('/settingsTeaserBuying/countries/Create');
        },
        showDeleteModal(country) {            
            this.selected = country;
            this.$refs.deleteModal.open();
        },
        deleteCountry(country) {
            this.$axios({
                method: 'DELETE',
                url: 'dashboardBuyingTypeCountries/' + country.id,
                errors: this.errors,
                success: () => {
                    this.countries = this.countries.filter((c) => c.id != country.id);
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Страна успешно удалена',
                        text: 'Страна успешно удалена',
                        color: 'success'
                    });
                },
                catch: (err) => {
                    this.$refs.deleteModal.close();
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка при удалении страны!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        }
    },
    components: {
        'v-select': vSelect,
        SweetModal,
        SweetModalTab
    }
};
</script>
